"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = UserInfo;

var _core = require("@material-ui/core");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _getInitials = _interopRequireDefault(require("../utils/getInitials"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      padding: theme.spacing(2),
      textAlign: "center"
    },
    profile: {
      margin: theme.spacing(2)
    },
    avatar: {
      margin: "18px auto",
      width: "75px",
      height: "75px",
      fontSize: "xx-large"
    },
    scope: {
      margin: theme.spacing(0.25)
    }
  };
});
/**
 * Menampilkan informasi user
 * @param {Object} param user info
 * @param {String} param.username
 * @param {String} param.first_name
 * @param {String} param.last_name
 * @param {String} param.email
 * @param {String} param.mobile
 * @param {Object[]} param.groups
 *
 */

function UserInfo(_ref) {
  var username = _ref.username,
      first_name = _ref.first_name,
      last_name = _ref.last_name,
      email = _ref.email,
      mobile = _ref.mobile,
      groups = _ref.groups;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_core.Paper, {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.profile
  }, /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
    className: classes.avatar
  }, (0, _getInitials["default"])("".concat(first_name || "", " ").concat(last_name || ""))), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "h5",
    display: "block",
    gutterBottom: true
  }, username), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "overline",
    display: "block",
    gutterBottom: true
  }, first_name, " ", last_name), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "caption",
    display: "block",
    gutterBottom: true
  }, /*#__PURE__*/_react["default"].createElement("span", {
    role: "img",
    "aria-label": "email-icon"
  }, "\uD83D\uDCE7", " "), /*#__PURE__*/_react["default"].createElement("span", null, email || " - ", " "), /*#__PURE__*/_react["default"].createElement("span", {
    role: "img",
    "aria-label": "phone-icon"
  }, "\uD83D\uDCF1", " "), /*#__PURE__*/_react["default"].createElement("span", null, mobile || " - ", " "))), /*#__PURE__*/_react["default"].createElement(_core.Divider, null), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.groups
  }, /*#__PURE__*/_react["default"].createElement(_core.Table, {
    size: "small",
    "aria-label": "group table"
  }, /*#__PURE__*/_react["default"].createElement(_core.TableHead, null, /*#__PURE__*/_react["default"].createElement(_core.TableRow, null, /*#__PURE__*/_react["default"].createElement(_core.TableCell, null, "Group"), /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
    align: "right"
  }, "Scope"))), /*#__PURE__*/_react["default"].createElement(_core.TableBody, null, groups && groups.length > 0 && groups.map(function (_ref2) {
    var id = _ref2.id,
        name = _ref2.name,
        scopes = _ref2.scopes;
    return /*#__PURE__*/_react["default"].createElement(_core.TableRow, {
      key: "".concat(id, "#").concat(name)
    }, /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
      component: "th",
      scope: "row"
    }, name, /*#__PURE__*/_react["default"].createElement("sup", null, "[", id, "]")), /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
      align: "right"
    }, scopes && scopes.length > 0 && scopes.map(function (_ref3) {
      var id = _ref3.id,
          name = _ref3.name;
      return /*#__PURE__*/_react["default"].createElement(_core.Chip, {
        key: "".concat(id, "#").concat(name),
        size: "small",
        label: name,
        className: classes.scope
      });
    })));
  })))));
}

UserInfo.propTypes = {
  username: _propTypes["default"].string,
  first_name: _propTypes["default"].string,
  last_name: _propTypes["default"].string,
  email: _propTypes["default"].string,
  mobile: _propTypes["default"].string,
  groups: _propTypes["default"].arrayOf(_propTypes["default"].object)
};